export function MenuInner() {
    return <></>;
}
